/* eslint-disable react/jsx-props-no-spreading */
import React from "react";

import { UploadOutlined } from "@ant-design/icons";
import { Button } from "antd";

import "./DragDrop.css";

export default function DragDrop(props) {
  const {
    uploadTarget, getRootProps, getInputProps,
  } = props;

  return (
    <div {...getRootProps({ className: "env-drag-drop" })}>
      <input
        {...getInputProps()}
      />
      <UploadOutlined className="env-drag-drop__icon" aria-hidden />
      <div className="env-drag-drop-header">
        Drag and drop to upload
        {" "}
        {uploadTarget}
      </div>
      <Button
        type="primary"
      >
        Browse
      </Button>
    </div>
  );
}
